import { Network } from '@nsfw-app/crypto'

// Return Testnet and Mainnet networks -> required in designs
export const getPolygonNetworks = (): Network[] => {
  return [Network.MUMBAI, Network.POLYGON]
}

export const getOptimismNetworks = (): Network[] => {
  return [Network.OPTIMISM, Network.OPTIMISM_GOERLI]
}

export const getArbitrumNetworks = (): Network[] => {
  return [Network.ARBITRUM, Network.ARBITRUM_GOERLI]
}

export const getBinanceNetworks = (): Network[] => {
  return [Network.BINANCE, Network.BINANCE_TESTNET]
}
